<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12 class="align-self-start">
        <v-layout wrap justify-center>
          <v-flex>
            <AppLogin
              v-if="winStep == 0"
              v-bind:pageData="pageData"
              v-bind:backgroundImage="backgroundImage"
              @stepper="winStepper"
            />
            <LoginVerify
              v-if="winStep == 1"
              v-bind:pageData="pageData"
              v-bind:backgroundImage="backgroundImage"
              @stepper="winStepper"
              v-bind:lastPage="lastPage"
            />
            <SignUp
              v-if="winStep == 2"
              v-bind:pageData="pageData"
              v-bind:backgroundImage="backgroundImage"
              @stepper="winStepper"
              v-bind:lastPage="lastPage" 
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
// import axios from "axios";
import AppLogin from "./../Login/loginForm";
import LoginVerify from "./../Login/loginVerify";
import SignUp from "./../Login/signUp";
export default {
  components: {
    AppLogin,
    LoginVerify,
    SignUp,
  },
  data() {
    return {
      winStep: 0,
      phone: null,
      pageData: {},
      lastPage: null,
      backgroundImage: null,
    };
  },
  beforeMount() {
    if (this.$route.params.lastPage)
      this.lastPage = this.$route.params.lastPage;
    // this.getImage();
  },
  methods: {
    // getImage() {
    //   axios({
    //     method: "GET",
    //     url: "/home/loginimage/get",
    //   }).then((response) => {
    //     this.backgroundImage = response.data.data.image;
    //   });
    // },
    winStepper(window_data) {
      this.winStep = window_data.winStep;
      this.pageData.phone = window_data.phone;
      if (window_data.response)
        this.pageData.pageResponse = window_data.response;
    },
  },
};
</script>
<style>
.login_page {
  background-color: #2aa86638;
  background-attachment: fixed;
  background-size: cover;
}
</style>